
import React from 'react';
import { UserRole } from '../types';
import { 
  LayoutDashboard, 
  Wrench, 
  Megaphone, 
  Vote, 
  Calendar as CalendarIcon, 
  ShieldCheck,
  Building as BuildingIcon,
  Users,
  MessageSquare,
  Wallet
} from 'lucide-react';

interface SidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  userRole: UserRole;
}

const Sidebar: React.FC<SidebarProps> = ({ activeTab, setActiveTab, userRole }) => {
  const isAdmin = userRole === UserRole.PRESIDENT || userRole === UserRole.DEPUTY || userRole === UserRole.SUPER_ADMIN;

  const menuItems = [
    { id: 'dashboard', label: 'Контролна табла', icon: LayoutDashboard },
    { id: 'announcements', label: 'Известувања', icon: Megaphone },
    { id: 'tickets', label: 'Одржување', icon: Wrench },
    { id: 'voting', label: 'Гласање и анкети', icon: Vote },
    { id: 'calendar', label: 'Календар', icon: CalendarIcon },
    { id: 'communication', label: 'Комуникација', icon: MessageSquare },
  ];

  if (isAdmin) {
    menuItems.push({ id: 'finances', label: 'Финансии', icon: Wallet });
    menuItems.push({ id: 'residents', label: 'Станари', icon: Users });
  }

  if (userRole === UserRole.SUPER_ADMIN) {
    menuItems.push({ id: 'buildings', label: 'Управувај згради', icon: BuildingIcon });
  }

  const getRoleLabel = (role: UserRole) => {
    switch(role) {
      case UserRole.SUPER_ADMIN: return 'Супер Админ';
      case UserRole.PRESIDENT: return 'Претседател';
      case UserRole.DEPUTY: return 'Заменик';
      case UserRole.TENANT: return 'Станар';
      default: return role;
    }
  };

  return (
    <aside className="w-20 md:w-64 bg-white border-r border-slate-200 flex flex-col h-screen sticky top-0">
      <div className="p-6 flex items-center space-x-2">
        <div className="bg-indigo-600 p-2 rounded-lg">
          <ShieldCheck className="w-6 h-6 text-white" />
        </div>
        <span className="hidden md:block text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-violet-600">
          CivicHome
        </span>
      </div>

      <nav className="flex-1 px-3 space-y-1 mt-4">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => setActiveTab(item.id)}
            className={`w-full flex items-center px-4 py-3 rounded-xl transition-all duration-200 ${
              activeTab === item.id
                ? 'bg-indigo-50 text-indigo-700 font-semibold'
                : 'text-slate-500 hover:bg-slate-50 hover:text-slate-900'
            }`}
          >
            <item.icon className={`w-5 h-5 ${activeTab === item.id ? 'text-indigo-600' : ''}`} />
            <span className="ml-3 hidden md:block text-sm">{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="p-4 border-t border-slate-100 hidden md:block">
        <div className="bg-slate-50 rounded-xl p-4">
          <p className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-2">Улога</p>
          <div className="flex items-center space-x-2">
            <div className={`w-2 h-2 rounded-full ${userRole === UserRole.TENANT ? 'bg-green-500' : 'bg-red-500'}`} />
            <span className="text-sm font-semibold text-slate-700">{getRoleLabel(userRole)}</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
